<template>
  <div class="page-container">
    <!-- 头部容器 -->
    <div class="header-container" v-if="true">
      <!-- 标题 -->
      <div class="title-container">
        <span class="symbol-icon"></span>
        <span class="title-text">{{ $str.getKey('收益管理/电表日历') }}</span>
      </div>
      
    </div>

    <!-- 主体容器 -->
    <div class="main-container">
      <div class="legend-container" v-if="panelData.legendList.length > 0">
        <template v-for="item in panelData.legendList">
          <el-popover placement="top" :width="400" trigger="hover">
            <template #reference>
              <div class="legend-item-container">
                <div class="symbol-icon" :style="{'--symbol-color': item.color}"></div>
                <div>{{item.name}}</div>
              </div>
            </template>
            <template #default>
              <div class="legend-tip-2501151706">
                <div class="tip-item">
                  <div class="segment-name">{{ $str.getKey('收益管理/尖峰时段') }}：</div>
                  <div class="time-list">
                    <template v-for="tr in item.segments.sharp" :key="tr">
                      <div class="tr-item">{{tr[0]}}~{{tr[1]}}</div>
                    </template>
                  </div>
                </div>
                <div class="tip-item">
                  <div class="segment-name">{{ $str.getKey('收益管理/高峰时段') }}：</div>
                  <div class="time-list">
                    <template v-for="tr in item.segments.peak" :key="tr">
                      <div class="tr-item">{{tr[0]}}~{{tr[1]}}</div>
                    </template>
                  </div>
                </div>
                <div class="tip-item">
                  <div class="segment-name">{{ $str.getKey('收益管理/平时段') }}：</div>
                  <div class="time-list">
                    <template v-for="tr in item.segments.flat" :key="tr">
                      <div class="tr-item">{{tr[0]}}~{{tr[1]}}</div>
                    </template>
                  </div>
                </div>
                <div class="tip-item">
                  <div class="segment-name">{{ $str.getKey('收益管理/低谷时段') }}：</div>
                  <div class="time-list">
                    <template v-for="tr in item.segments.valley" :key="tr">
                      <div class="tr-item">{{tr[0]}}~{{tr[1]}}</div>
                    </template>
                  </div>
                </div>
                <div class="tip-item">
                  <div class="segment-name">{{ $str.getKey('收益管理/深谷时段') }}：</div>
                  <div class="time-list">
                    <template v-for="tr in item.segments.deepValley" :key="tr">
                      <div class="tr-item">{{tr[0]}}~{{tr[1]}}</div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </el-popover>
        </template>
      </div>
      <div class="calendars-container">
        <div v-for="month in panelData.monthList" :key="month" class="test-container">
          <MonthCalendar :month="month"></MonthCalendar>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick, onMounted } from "vue"
import dayjs from 'dayjs';
import MonthCalendar from './monthCalendar.vue';

const $str = window.$str;

/** 属性传递：接收父组件传递下来的数据 */
const props = defineProps({
  year: {
    type: [Object, String],
    default: ''
  },
  ruleList: {
    type: Array,
    default: []
  },
});

const panelData = reactive({
  monthList: [],
  legendList: [],
})





watch(() => props.year, nv => {
  refreshMonthList(nv);
},{immediate:true})


watch(() => props.ruleList, nv => {
  refreshLegendList(nv);
},{immediate:true, deep:true})





/** ====== [业务：功能方法] =================================================================== */
/** 刷新：日历中的月份列表 */
function refreshMonthList(year) {
  const firstDay = dayjs(year).startOf('day');
  const monthList = [];
  for (let i = 0; i < 12; i++) {
    const monthStr = firstDay.add(i,'month').format('YYYY-MM');
    monthList.push(monthStr);
  }
  panelData.monthList = monthList;
}

/** 刷新：图例列表的数据 */
function refreshLegendList(ruleList) {
  panelData.legendList = ruleList;
}



/** ====== [辅助：功能方法] =================================================================== */









</script>
<style lang="scss" scoped>
.page-container {
  --header-hight: 50px;
  & {
    width: 100%;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    min-height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-container {
      max-width: 50%;
      height: 100%;
      padding-left: 6px;
      display: flex;
      align-items: center;
      gap: 10px;

      .symbol-icon {
        width: 4px;
        height: 20px;
        background: #485e91;
      }
      .title-text {
        font-size: 18px;
      }
    }

  }


  .main-container {
    & {
      width: 100%;
      // height: 660px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      box-sizing: border-box;
      padding: 10px;
      background: var(--level2-bg-color);
      border: 1px solid rgba(0, 0, 0, 0.08);
    }

    .legend-container {
      width: 100%;
      height: 40px;
      // min-height: 40px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;

      .legend-item-container {
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 6px;

        .symbol-icon {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background-color: var(--symbol-color);
        }

      }

    }

    .calendars-container {
      width: 100%;
      height: 100%;
      flex: 1;
      overflow: hidden;
      
      display: grid; /* 设置为网格布局 */
      grid-template-columns: repeat(6, 1fr); /* 三列 */
      grid-template-rows: repeat(2, 1fr); /* 两行 */
      gap: 10px;

      .test-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }


  }


  
}
</style>
<style lang="scss">

  .legend-tip-2501151706 {
      min-height: 100px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    .tip-item {
      font-size: 14px;
      display: flex;
      gap: 6px;

      .segment-name {
        min-width: 70px;
      }

      .time-list {
        display: flex;
        gap: 10px;
        .tr-item {
          width: 90px;
        }
      }
    }
  }

</style>
